import { createContext } from 'react';

const LockContext = createContext({});

export default LockContext;
